/**
 * Just Jess — cup size image strip + main-image swap (theme assets only).
 * No-ops unless #jj-cup-size-config is present (cup product).
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function parseConfig() {
    var el = document.getElementById('jj-cup-size-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function normalizeSize(label) {
    if (!label) return null;
    var s = String(label).toLowerCase().replace(/\s+/g, '');
    if (s.indexOf('16') !== -1) return '16oz';
    if (s.indexOf('18') !== -1) return '18oz';
    if (s.indexOf('20') !== -1) return '20oz';
    return null;
  }

  function sizeFromVariant(variant, config) {
    if (!variant) return null;
    if (variant.id && config.variants && config.variants[String(variant.id)]) {
      return config.variants[String(variant.id)].size;
    }
    var opts = variant.options || [];
    for (var i = 0; i < opts.length; i++) {
      var n = normalizeSize(opts[i]);
      if (n) return n;
    }
    if (variant.title) return normalizeSize(variant.title);
    return null;
  }

  function mainMediaImgs() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        '.product__media-wrapper img, media-gallery img, .product__media img, .product-media-container img'
      )
    );
  }

  function setMainImage(url, alt) {
    if (!url) return;
    var imgs = mainMediaImgs();
    if (!imgs.length) return;
    imgs.forEach(function (img) {
      // Prefer primary visible / first media
      img.src = url;
      if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
      if (alt) img.alt = alt;
      // Also update parent <picture> sources if any
      var pic = img.closest('picture');
      if (pic) {
        Array.prototype.forEach.call(pic.querySelectorAll('source'), function (src) {
          src.removeAttribute('srcset');
        });
      }
    });

    // Dawn media-gallery: try setActiveMedia if a matching media id exists (usually won't for theme assets)
    var gallery = document.querySelector('media-gallery');
    if (gallery && typeof gallery.setActiveMedia === 'function' && imgs[0]) {
      var mediaId = imgs[0].closest('[data-media-id]');
      if (mediaId) {
        try {
          gallery.setActiveMedia(mediaId.getAttribute('data-media-id'), false);
        } catch (e) {}
      }
    }
  }

  function selectSizeInput(sizeLabel) {
    // Match radio/button inputs for Size option
    var inputs = document.querySelectorAll(
      'variant-selects input[type="radio"], fieldset.product-form__input input[type="radio"]'
    );
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var val = input.value || '';
      if (normalizeSize(val) === sizeLabel) {
        if (!input.checked) {
          input.click();
        }
        return true;
      }
    }
    // Dropdown fallback
    var selects = document.querySelectorAll('variant-selects select');
    for (var j = 0; j < selects.length; j++) {
      var sel = selects[j];
      for (var k = 0; k < sel.options.length; k++) {
        if (normalizeSize(sel.options[k].value) === sizeLabel) {
          if (sel.selectedIndex !== k) {
            sel.selectedIndex = k;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
          }
          return true;
        }
      }
    }
    return false;
  }

  function ensureStrip(config) {
    if (document.querySelector('.jj-cup-size-strip')) return document.querySelector('.jj-cup-size-strip');
    var anchor =
      document.querySelector('variant-selects') ||
      document.querySelector('.product-form__input') ||
      document.querySelector('.product__info-container');
    if (!anchor) return null;

    var strip = document.createElement('div');
    strip.className = 'jj-cup-size-strip';
    strip.setAttribute('role', 'list');
    strip.setAttribute('aria-label', 'Cup sizes');

    (config.sizes || []).forEach(function (item) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'jj-cup-size-strip__btn';
      btn.setAttribute('role', 'listitem');
      btn.dataset.size = item.size;
      btn.dataset.variantId = String(item.variantId || '');
      btn.setAttribute('aria-label', item.label + ' ' + item.price);

      var img = document.createElement('img');
      img.src = item.image;
      img.alt = item.label;
      img.width = 72;
      img.height = 88;
      img.loading = 'lazy';

      var lab = document.createElement('span');
      lab.className = 'jj-cup-size-strip__label';
      lab.innerHTML =
        item.label +
        ' <span class="jj-cup-size-strip__price">' +
        item.price +
        '</span>';

      btn.appendChild(img);
      btn.appendChild(lab);
      btn.addEventListener('click', function () {
        selectSizeInput(item.size);
        applySize(item.size, config);
      });
      strip.appendChild(btn);
    });

    if (anchor.tagName && anchor.tagName.toLowerCase() === 'variant-selects') {
      anchor.parentNode.insertBefore(strip, anchor);
    } else {
      anchor.insertBefore(strip, anchor.firstChild);
    }
    return strip;
  }

  function markActive(size) {
    document.querySelectorAll('.jj-cup-size-strip__btn').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.size === size);
    });
  }

  function applySize(size, config) {
    if (!size || !config.images || !config.images[size]) return;
    var url = config.images[size];
    setMainImage(url, 'Custom cup ' + size);
    markActive(size);
  }

  function currentSizeFromDom() {
    var checked = document.querySelector(
      'variant-selects input[type="radio"]:checked, fieldset.product-form__input input[type="radio"]:checked'
    );
    if (checked) return normalizeSize(checked.value);
    var sel = document.querySelector('variant-selects select');
    if (sel) return normalizeSize(sel.value);
    return null;
  }

  function bindVariantListeners(config) {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      try {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          var variant = event && (event.data && event.data.variant ? event.data.variant : event.variant);
          var size = sizeFromVariant(variant, config) || currentSizeFromDom();
          applySize(size, config);
        });
      } catch (e) {}
    }

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.matches && (t.matches('variant-selects input') || t.matches('variant-selects select') || t.name && /Size/i.test(t.name))) {
        var size = normalizeSize(t.value) || currentSizeFromDom();
        applySize(size, config);
      }
    });
  }

  ready(function () {
    var config = parseConfig();
    if (!config || !config.enabled) return;
    ensureStrip(config);
    bindVariantListeners(config);
    var initial = currentSizeFromDom() || (config.defaultSize || '16oz');
    applySize(initial, config);
  });
})();
